export default __webpack_public_path__ + "static/media/featured-grey.31342734.svg";